<div class="ion-padding pb-48">
  <div class="container pb-12">
    <section class="my-6">
      <h2 class="text-2xl font-bold mb-2">{{ 'job.heading' | t }}</h2>
      <p class="text-slate-600 dark:text-slate-300 mb-4">{{ name }} — Analyst Developer / Front-end leader</p>
    </section>

    <section class="space-y-6">
      <ion-card *ngFor="let job of jobs">
        <ion-card-header>
          <ion-card-subtitle>{{ job.company }} — {{ job.location }}</ion-card-subtitle>
          <ion-card-title>{{ job.title }}</ion-card-title>
          <div class="text-sm text-slate-500">{{ job.period }} · {{ job.duration }}</div>
        </ion-card-header>
        <ion-card-content>
          <p class="mb-2">{{ getLocalized(job,'description') }}</p>
          <div class="flex flex-wrap gap-2 mt-2">
            <span *ngFor="let c of job.skills" class="px-2 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-sm">{{ c }}</span>
          </div>
        </ion-card-content>
      </ion-card>
    </section>

    <section class="mt-6">
      <h3 class="text-xl font-semibold mb-4">{{ 'education.heading' | t }}</h3>
      <div class="space-y-4">
        <ion-card *ngFor="let e of educations">
          <ion-card-header>
              <ion-card-title>{{ getLocalized(e,'degree') }}</ion-card-title>
            <ion-card-subtitle>{{ e.institution }} — {{ e.year }}</ion-card-subtitle>
            <div *ngIf="e.grade" class="text-sm text-slate-500">Votazione: {{ e.grade }}</div>
          </ion-card-header>
          <ion-card-content>
              <div class="text-sm mb-2" *ngIf="e.activities">Attività: {{ getLocalized(e,'activities') }}</div>
            <div class="flex flex-wrap gap-2">
              <span *ngFor="let s of e.skills" class="px-2 py-1 rounded-full bg-slate-100 dark:bg-slate-800 text-sm">{{ s }}</span>
            </div>
          </ion-card-content>
        </ion-card>
      </div>
    </section>

    <!-- spacer to ensure page can scroll past the last card on small viewports -->
    <div class="h-48" aria-hidden="true"></div>
  </div>
</div>
